import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";

import Home from "./pages/marketing/Home";
import Products from "./pages/marketing/Products";
import ProductCRM from "./pages/marketing/ProductCRM";
import { Services, ServiceDetail } from "./pages/marketing/Services";
import { Solutions, SolutionDetail } from "./pages/marketing/Solutions";
import About from "./pages/marketing/About";
import Contact from "./pages/marketing/Contact";
import Industries from "./pages/marketing/Industries";
import LeadSystemAudit from "./pages/marketing/LeadSystemAudit";
import LeadToClient from "./pages/marketing/LeadToClient";
import CampaignLanding from "./pages/marketing/CampaignLanding";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import HostedForm from "./pages/public/HostedForm";

import CrmLayout from "./components/crm/CrmLayout";
import Dashboard from "./pages/crm/Dashboard";
import Contacts from "./pages/crm/Contacts";
import ContactDetail from "./pages/crm/ContactDetail";
import FollowUps from "./pages/crm/FollowUps";
import Pipelines from "./pages/crm/Pipelines";
import Forms from "./pages/crm/Forms";
import QRCodes from "./pages/crm/QRCodes";
import Events from "./pages/crm/Events";
import Campaigns from "./pages/crm/Campaigns";
import Imports from "./pages/crm/Imports";
import Reports from "./pages/crm/Reports";
import Integrations from "./pages/crm/Integrations";
import Settings from "./pages/crm/Settings";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/app/login" replace />;
  return <CrmLayout>{children}</CrmLayout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Marketing */}
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/crm" element={<ProductCRM />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/solutions/lead-to-client" element={<LeadToClient />} />
          <Route path="/solutions/:slug" element={<SolutionDetail />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/lead-system-audit" element={<LeadSystemAudit />} />
          <Route path="/go/:slug" element={<CampaignLanding />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* Auth */}
          <Route path="/app/login" element={<Login />} />
          <Route path="/app/register" element={<Register />} />

          {/* Public hosted form */}
          <Route path="/f/:orgSlug/:formSlug" element={<HostedForm />} />

          {/* CRM app */}
          <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
          <Route path="/app/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/app/contacts" element={<Protected><Contacts /></Protected>} />
          <Route path="/app/contacts/:id" element={<Protected><ContactDetail /></Protected>} />
          <Route path="/app/follow-ups" element={<Protected><FollowUps /></Protected>} />
          <Route path="/app/pipelines" element={<Protected><Pipelines /></Protected>} />
          <Route path="/app/forms" element={<Protected><Forms /></Protected>} />
          <Route path="/app/qr-codes" element={<Protected><QRCodes /></Protected>} />
          <Route path="/app/events" element={<Protected><Events /></Protected>} />
          <Route path="/app/campaigns" element={<Protected><Campaigns /></Protected>} />
          <Route path="/app/imports" element={<Protected><Imports /></Protected>} />
          <Route path="/app/reports" element={<Protected><Reports /></Protected>} />
          <Route path="/app/integrations" element={<Protected><Integrations /></Protected>} />
          <Route path="/app/settings" element={<Protected><Settings /></Protected>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
